import PropTypes from 'prop-types'
import { Component } from 'react'

import { DraftButton } from '../NarusMaterial'

export class Draft extends Component {
  render () {
    const form = this.context?.form
    if (form?.props?.draft) {
      return <DraftButton draft={form?.state?.draft} />
    }
    return null
  }
}

Draft.contextTypes = {
  form: PropTypes.instanceOf(Object)
}
